import React from 'react';

export default function LiveDot({ live, dark = false, testId = 'recovery-live-dot' }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-[10.5px] font-bold ${dark ? 'text-white/80' : 'text-slate-500'}`} data-testid={testId} data-live={live ? 'on' : 'off'}>
      <span className={`w-2 h-2 rounded-full ${live ? 'bg-emerald-400 animate-pulse' : 'bg-slate-400'}`} />
      {live ? 'Live' : 'Offline'}
    </span>
  );
}
